import groupBy from "lodash/groupBy";
import {TriangleAlert} from "lucide-react";
import {ICON_SIZE} from "components/common/constants";
import {Notification, NotificationType} from "components/common/Notification.component";
import {Tooltip} from "components/tooltip/Tooltip";
import type {TopWarningsProps, WarningsTooltipProps} from "types/documentData";

export const WarningIcon = () => (
    <TriangleAlert size={ICON_SIZE.SMALL} className="document-data__warning-icon" aria-hidden="true"/>
);

// the warnings of one field or of the whole document, each source with its own messages under it
const WarningsBySource = ({warnings}: TopWarningsProps) => {
    const warningsBySource = groupBy(warnings, warning => warning.source);

    return (
        <>
            {Object.keys(warningsBySource).map(source =>
                <span key={source} className="document-data__warnings-source">
                    <strong>{source}</strong>
                    {warningsBySource[source].map(warning =>
                        <span key={warning.message} className="document-data__warning-message">{warning.message}</span>)}
                </span>)}
        </>
    );
};

// the tooltip reads its content from a function, made here so no component is defined inside another
const warningsTooltipContent = (warnings: WarningsTooltipProps["warnings"]) =>
    () => <WarningsBySource warnings={warnings}/>;

/** The warnings of a field, shown while the field is hovered or focused. */
export const WarningsTooltip = ({id, warnings}: WarningsTooltipProps) => (
    <Tooltip id={id} content={warningsTooltipContent(warnings)}/>
);

/** The warnings about no field the panel shows, above the fields. */
export const TopWarnings = ({warnings}: TopWarningsProps) => (
    <div className="document-data__top-warnings" data-cy="taskDetail.detailsPanel.warnings">
        <Notification type={NotificationType.WARNING} description={<WarningsBySource warnings={warnings}/>}/>
    </div>
);
